import { Box, Breadcrumbs, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography, Button, LinearProgress } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import APIInvoke from '../../utils/APIInvoke'
import { useParams, useNavigate, Link, useLocation, useSearchParams } from "react-router-dom";
import ConfirmDialog from '../../template/ConfirmDialog';
import { toast } from 'react-hot-toast';
import DeleteIcon from '@mui/icons-material/Delete';
import AppContext from '../../state/AppContext';
import WarningIcon from '@mui/icons-material/Warning';
import { DateTime } from 'luxon';
import { setLoading } from '../../template/app-actions';
import * as Permissions from '../../utils/Permissions'
import GrantContent from '../../template/GrantContent';
import Header from '../../template/Header';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { fromISOToUTCFormat } from '../../utils/DateUtilsUTC';
import QueryBuilder, { getOperators, keyOperators } from '../../components/QueryBuilder/QueryBuilder';
import { useSelector } from 'react-redux';
import SettingsIcon from '@mui/icons-material/Settings';
import { restoreQueryParams } from './collection-actions';
import GrantBreadcrumbs from '../../template/GrantBreadcrumbs';

const columns = [
    {
        field: 'key',
        headerName: 'Key',
        align: "left"
    }, {
        field: 'datetime',
        headerName: 'Update At',
        align: "left"
    }, {
        field: 'user',
        headerName: 'Updated By',
        align: "left"
    }, {
        field: 'revision',
        headerName: 'Revisions',
        align: "left"
    }, {
        field: 'errors',
        headerName: 'Errors',
        align: "center"
    }, {
        field: 'action',
        headerName: 'Action',
        align: "right"
    }
]

// inputType: number, time, datetime-local, date
// valueEditorType: 'textarea'




const initialState = {
    pageSize: 10,
    totalItems: 0,
    currentPage: 0,
    totalPages: 0,
    items: [],
    query: undefined,
    queryBuilder: undefined,
    showDeleteDialog: {
        open: false,
        payload: null
    }
}





const Collection = (props) => {



    let { collection } = useParams()
    const { appContext } = useContext(AppContext)
    const project = appContext.project
    const navigate = useNavigate()
    const location = useLocation();
    const backLink = location.state?.backLink;
    const { loading } = useSelector(state => state.pages.app)
    const [state, setState] = useState(restoreQueryParams(project, collection))
    const [collectionObject, setCollectionObject] = useState(null)
    const [fields, setFields] = useState([
        { name: 'key', label: 'Key', inputType: "string", operators: keyOperators, defaultOperator: "=" },
        { name: 'lastReceivedAt', label: 'Last Received At', inputType: "datetime-local", operators: keyOperators, defaultOperator: "=" }
    ])
    const [query, setQuery] = useState(restoreQueryParams(project, collection).queryBuilder)

    useEffect(() => {
        fetchCollection()
    }, [])

    const fetchCollection = async () => {

        const getDefaultOperators = (fieldName, type) => {

            if (fieldName === "key") {
                return "=";
            } else if (fieldName === "lastReceivedAt") {
                return ">=";
            } else if (type === "datetime") {
            }

            switch (type) {
                case "string":
                    return "contains";
                default:
                    return "=";
            }
        }

        const getInputType = (type) => {
            if (type === "boolean") {
                return "checkbox";
            } else if (type === "datetime") {
                return "datetime-local";
            } else if (type === "date") {
                return "date";
            } else if (type === "time") {
                return "time";
            }
            return type;
        }

        try {
            const response = await (await APIInvoke.invokeGET(`/projects/${project}/collections/${collection}`)).json()
            if (response.ok) {
                setCollectionObject(response.body)
                setState({
                    ...state,
                });
                setFields(response.body.schema.fields.map(field => ({
                    name: field.fieldName,
                    placeholder: field.placeholder,
                    label: field.fieldName,
                    type: field.type,
                    inputType: getInputType(field.type),
                    valueEditorType: getInputType(field.type),
                    operators: getOperators(field.fieldName, field.type),
                    defaultOperator: getDefaultOperators(field.fieldName, field.type)
                    //field.type === "string" ? "contains" : "="
                })));
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            console.error("Error lo load collection", error)
        } finally {
            //setLoading(false)
        }
    }

    const handleChangePage = (e, newPage) => {
        setQueryParam('currentPage', newPage)
        const newState = {
            ...state,
            currentPage: newPage
        }
        setState(newState)
        fetchDocuments(newState)
    }

    const onRowsPerPageChange = (event) => {
        setQueryParam('pageSize', event.target.value)
        const newState = {
            ...initialState,
            query: state.query,
            queryBuilder: state.queryBuilder,
            items: state.items,
            pageSize: parseInt(event.target.value, 10),
        }
        setState(newState)
        fetchDocuments(newState)
    }

    const onRowClick = (event, row, index) => {

        const offset = state.currentPage * state.pageSize + index
        const queryStorage = {
            query: state.query,
            queryBuilder: state.queryBuilder,
            currentPage: state.currentPage,
            pageSize: state.pageSize,
            totalItems: state.totalItems,
            totalPages: state.totalPages,
            offset: offset
        }
        sessionStorage.setItem(`${project}-${collection}-query`, JSON.stringify(queryStorage));
        navigate(`/projects/${project}/collections/${collection}/documents/${row.id}`, { state: { backLink: location.pathname } })
    }

    const onDelete = async () => {
        try {
            setLoading(true)
            const response = await (await APIInvoke.invokeDELETE(`/projects/${project}/collections/${collection}/documents/${state.showDeleteDialog.payload.id}`)).json()
            if (response.ok) {
                toast.success(response.message)
                setState({
                    ...state,
                    items: state.items.filter(x => x.id !== state.showDeleteDialog.payload.id),
                    showDeleteDialog: { open: false, payload: null }
                })
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error("Unxpected error")
        } finally {
            setLoading(false)
        }

    }

    const toggleDeleteDialog = (event, payload) => {
        event.stopPropagation()
        setState({
            ...state,
            showDeleteDialog: {
                open: !state.showDeleteDialog.open,
                payload
            }
        })
    }

    const onApply = (query, queryBuilder) => {
        const newState = {
            ...state,
            query,
            queryBuilder
        }
        setState(newState)
        setQuery(queryBuilder)

        const query64 = btoa(JSON.stringify({
            query,
            queryBuilder
        }));

        

        setQueryParam('query', query64);
        fetchDocuments(newState);
    }

    const setQueryParam = (key, value, replace = true) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set(key, value);
        navigate(`?${searchParams.toString()}`);
    }

    const fetchDocuments = async (newState) => {
        try {
            setLoading(true);
            const query64 = btoa(newState.query);
            const startTime = DateTime.now()
            const rawResponse = await APIInvoke.invokeGET(`/projects/${project}/collections/${collection}/documents/query?query=${query64}&page=${newState?.currentPage || 0}&size=${newState?.pageSize || 10}&projection=id,key,project,collection,lastUpdateBy,lastUpdateAt,lastReceivedAt,lastRevision,schemaErrors,isValid`)
            if (rawResponse.status === 408) {
                toast.error("Timeout to execute query, try create a more specific query, the response time was " + DateTime.now().diff(startTime, 'seconds').seconds + " seconds");
                return;
            }
            const response = await (rawResponse).json()
            if (response.ok) {
                setState({
                    ...newState,
                    items: response.body.items,
                    totalItems: response.body.totalItems,
                    currentPage: response.body.currentPage,
                    totalPages: response.body.totalPages,
                    pageSize: response.body.pageSize
                });
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            console.error("Error lo load page", error)
        } finally {
            setLoading(false);
        }
    }

    if (!collectionObject) {
        return (
            <div>
                <Header title="Collection" backLink={backLink !== undefined ? backLink : `/projects/${project}/collections`} >
                    <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600" >
                        <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                        <GrantBreadcrumbs permisos={[Permissions.COLLECTIONS_R]} text="Collections" link={`/projects/${project}/collections`} />
                        <Typography ><span className="text-gray-600">{collection}</span></Typography>
                    </Breadcrumbs>
                </Header>



                <div className="content grid gap-8">
                    <div className="layout grid gap-4">
                        <div className="flex justify-between items-center">
                            <h4 className="capitalize">
                                <div>Loading...</div>
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="">
            <ConfirmDialog title="Delete document" message="This action is permanent and there will be no way to recover the document" open={state.showDeleteDialog.open} onClose={toggleDeleteDialog} onConfirm={onDelete} />
            <Header title="Collection" backLink={`/projects/${project}/collections`}  >
                <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600" >
                    <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                    <GrantBreadcrumbs permisos={[Permissions.COLLECTIONS_R]} text="Collections" link={`/projects/${project}/collections`} />
                    <Typography ><span className="text-gray-600">{collection}</span></Typography>
                </Breadcrumbs>
            </Header>
            <div className="content grid gap-8">
                <div className="layout grid gap-4">
                    <div className="flex justify-between items-center">
                        <h4 className="capitalize">
                            {collection}
                        </h4>
                        <GrantContent permisos={[Permissions.COLLECTIONS_W]}>
                            {(canAccess, roles, permisos, isPage) => (
                                <Tooltip title={canAccess ? "Configure" : `You don't have permission to configure this collection, required permissions: ${permisos.join(", ")}`}>
                                    <span>
                                        <Button variant="contained" disabled={!canAccess} LinkComponent={Link} to={`/projects/${project}/collections/${collection}/edit`} state={{ backLink: window.location.pathname }}><SettingsIcon className="mr-1" /> CONFIGURE</Button>
                                    </span>
                                </Tooltip>
                            )}
                        </GrantContent>
                    </div>
                </div>
                <div className="grid gap-8">
                    <Box>
                        <Paper>
                            <QueryBuilder
                                fields={fields}
                                initialQuery={query}
                                onApply={onApply}
                                fireInitialApply={true}
                                debug={true}
                            />

                            {loading && <LinearProgress size="sm" />}
                            <TableContainer style={{ maxHeight: "calc( 100vh - 250px )" }}>
                                <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"small"}  >
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((headCell, index) => (
                                                <TableCell key={index} align={headCell.align} padding={'normal'} >
                                                    {headCell.headerName}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {state.items === undefined
                                            ? (
                                                <TableRow >
                                                    <TableCell colSpan={6}>
                                                        <Box>
                                                            <div className="p-4">
                                                                <LinearProgress />
                                                            </div>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                state.items.map((row, index) => {
                                                    return (
                                                        <TableRow
                                                            hover
                                                            onClick={(event) => onRowClick(event, row, index)}
                                                            tabIndex={-1}
                                                            key={row.id}
                                                            sx={{ cursor: 'pointer' }}
                                                        >
                                                            <TableCell align="left">{row.key}</TableCell>
                                                            <TableCell align="left">{fromISOToUTCFormat(row.lastReceivedAt, 'dd/MM/yyyy HH:mm:ss')}</TableCell>
                                                            <TableCell align="left">{row.lastUpdateBy}</TableCell>
                                                            <TableCell align="left" width={10} >{row.lastRevision}</TableCell>
                                                            <TableCell align="center" width={10} >
                                                                {!row.valid && (
                                                                    <Tooltip title={row.schemaErrors} >
                                                                        <WarningIcon fontSize="small" className="text-red" />
                                                                    </Tooltip>
                                                                )}
                                                            </TableCell>
                                                            <TableCell width={10} align="right">
                                                                <GrantContent permisos={[Permissions.COLLECTIONS_D]}>
                                                                    {(canAccess, roles, permisos, isPage) => (
                                                                        <Tooltip title={canAccess ? "Delete" : `You don't have permission to delete this document, required permissions: ${permisos.join(", ")}`}>
                                                                            <span>
                                                                                <IconButton disabled={!canAccess} onClick={(event) => toggleDeleteDialog(event, row)} ><DeleteIcon className="hover:text-red" /></IconButton>
                                                                            </span>
                                                                        </Tooltip>
                                                                    )}
                                                                </GrantContent>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {loading && <LinearProgress size="sm" />}
                            <TablePagination
                                rowsPerPageOptions={[10, 20, 50, 100]}
                                component="div"
                                rowsPerPage={state.pageSize}
                                count={state.totalItems}
                                page={state.currentPage}
                                disabled={loading}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={onRowsPerPageChange}
                            />

                        </Paper>
                    </Box>
                </div>
            </div>
        </div>
    )
}

export default Collection